export const PUSH = '@queue/PUSH';
export const POP = '@queue/POP';
export const REMOVE = '@queue/REMOVE';
export const CLEAR_QUEUE = '@queue/CLEAR_QUEUE';
